














































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class workflow_toolbar extends Vue {
  @Prop({ type: String, required: true }) value!: string;

  triggerImport() {
    const el = this.$refs.fileInput as HTMLInputElement;
    if (el) el.click();
  }

  handleImportChange(e: Event) {
    const input = e.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev: any) => {
      try {
        const json = JSON.parse(ev.target.result);
        this.$emit("import", json);
      } catch (err) {
        this.$emit("import-error", err);
      } finally {
        // limpiar valor para permitir mismo archivo de nuevo
        if (input) input.value = "";
      }
    };
    reader.readAsText(file);
  }
}
